import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Scrollbars } from "react-custom-scrollbars";
import Popover from "module-common/Popover";

export default class Picker extends Component {
  static propTypes = {
    position: PropTypes.oneOf(["top", "bottom"]),
    children: PropTypes.any,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.any,
        selected: PropTypes.bool
      })
    ),
    width: PropTypes.number,
    maxMenuScroll: PropTypes.number,
    hideOnSelect: PropTypes.bool,
    onSelected: PropTypes.func,
    disabled: PropTypes.bool
  };
  static defaultProps = {
    position: "bottom",
    options: [],
    width: 150,
    maxMenuScroll: 4,
    hideOnSelect: true,
    disabled: false
  };

  render() {
    const { children, hideOnSelect, options, ...rest } = this.props;
    return options.length === 0 ? (
      this.props.children
    ) : (
      <Popover
        {...rest}
        show="click"
        hide={hideOnSelect ? "click" : "click-outside"}
        content={this.renderMenu()}
      >        
        {children}
      </Popover>
    );
  }

  renderMenu = () => {
    const { width, position, options, maxMenuScroll, disabled } = this.props;
    let count = options.length;
    if (count > maxMenuScroll) count = maxMenuScroll;
    return (
      <Menu
        position={position}
        height={count * 40 + 12}
        width={width}
        disabled={disabled}
      >
        <Scrollbars>
          {options.map((row, i) => (
            <Row
              key={i}
              selected={row.selected}
              onClick={evt => this.onRowClick(evt, row)}
            >
              {row.label}
            </Row>
          ))}
        </Scrollbars>
      </Menu>
    );
  };

  onRowClick = (evt, row) => {
    const { options, onSelected } = this.props;
    if (onSelected) onSelected(row, options);
  };
}

const Menu = styled.div`
  display: ${props => (props.disabled ? "none" : "block")};
  padding: 6px;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  border-radius: 6px;
  box-shadow: ${props => props.theme.shadow};
  background-color: white;
  word-break: keep-all;
  overflow-wrap: break-word;
`;
const Row = styled.div`
  width: 100%;
  min-height: 35px;
  padding: 8px;
  margin-bottom: 5px;
  color: ${props => props.theme.uiText};
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
  &:first-letter {
    text-transform: capitalize;
  }
  &:hover {
    background-color: ${props => props.theme.blueButton};
    color: white;
    border-radius: 4px;
  }
  ${props =>
    props.selected &&
    css`
       {
        background-color: ${props.theme.blueButton};
        color: white;
        border-radius: 4px;
      }
    `};
`;



// WEBPACK FOOTER //
// ./src/module-common/Picker.js